import { AlkLogger } from '@alk/core';
import { ARRAY_OF_INSTRUMENTS_01 } from '../../mocks/instruments.data';
import { DATA_01 } from '../../mocks/pad-result.data';
import { ExtractionResult, ExtractionSelector } from '../../interfaces/functions.interface';
import { injectable } from 'inversify';
import { IPadConfig, IPadResult, IPlaceOrderResponse } from '../../interfaces';
import { IPadConfigService } from './pad-config.interface';
import { Observable, of } from 'rxjs';
import { observableSelector } from '../../helpers';
import { SecuritySymbol } from '@fnx/fx-pad';
import { transformSecurityItemWithType } from './pad-config.service.utils';

const mockConfigState: IPadResult = {
    ...DATA_01,
    instruments: ARRAY_OF_INSTRUMENTS_01.map(transformSecurityItemWithType),
    allInstruments: ARRAY_OF_INSTRUMENTS_01.map(transformSecurityItemWithType),
};

@injectable()
export class PadConfigMock implements IPadConfigService {
    toggleFeed(): void {
        AlkLogger.info('[PadConfigMock] toggleFeed');
    }
    placeOrder(): void {
        AlkLogger.info('[PadConfigMock] order placed');
    }
    public configObservable = <S extends ExtractionSelector<IPadResult>>(request: S):
    Observable<ExtractionResult<IPadResult, S>> =>
        of(mockConfigState).pipe(observableSelector(request));

    start(id: string): void {
        AlkLogger.info('[PadConfigMock] start', id);
    }

    stop(): void {
        AlkLogger.info('[PadConfigMock] stop');
    }

    update(config: Partial<IPadConfig>): void {
        AlkLogger.info('[PadConfigMock] update', config);
    }

    handleInstruments(instruments: Array<SecuritySymbol>) : void {
        AlkLogger.info('[PadConfigMock] handleInstruments', instruments);
    }

    startStopPricing(): void {
        AlkLogger.info('[PadConfigMock] startStopPricing');
    }

    getOrderResponse(): Observable<IPlaceOrderResponse> {
        AlkLogger.info('[PadConfigMock] getOrderResponse');
        return of({ isAccepted: true, reason: 'ok' });
    }
}
